export default __webpack_public_path__ + "static/media/tikal.a793199d.jpg";